import { rootApi } from '../rootApi';

/**
 * LMS Rapor Katılımcıları — `/v1/LmsTrainingReportParticipant`.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §5.
 *
 * `kunnr` (bayi SAP kodu) opsiyoneldir; gönderildiğinde backend 10 haneye sıfırla
 * tamamlayarak saklar ve cevapta o biçimde döner (doc §5.2). Karsan içi / bayi dışı
 * katılımcı için `kunnr` gönderilmemelidir.
 */
export const lmsTrainingReportParticipantApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingReportParticipants: builder.query({
            query: ({ trainingReportId, kunnr, participantName, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingReportParticipant/GetList',
                method: 'POST',
                body: {
                    trainingReportId: trainingReportId ?? null,
                    kunnr: kunnr || null,
                    participantName: participantName || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingReportParticipant']
        }),

        getLmsTrainingReportParticipantById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingReportParticipant/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingReportParticipant']
        }),

        addLmsTrainingReportParticipant: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReportParticipant/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReportParticipant']
        }),

        updateLmsTrainingReportParticipant: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReportParticipant/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReportParticipant']
        }),

        deleteLmsTrainingReportParticipant: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingReportParticipant/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingReportParticipant']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingReportParticipantsQuery,
    useGetLmsTrainingReportParticipantByIdQuery,
    useAddLmsTrainingReportParticipantMutation,
    useUpdateLmsTrainingReportParticipantMutation,
    useDeleteLmsTrainingReportParticipantMutation
} = lmsTrainingReportParticipantApi;
